import React, { useContext, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { formatPhoneNumber } from 'react-phone-number-input'

export default function LabelFieldPhoneComponent({ 
    label, 
    labelDir, 
    fieldSize, 
    option, 
    onChange, 
    phoneNumber, 
    placeholder,
    errorMessage='',
    showArrow=true,
    required, 
    onCountryChange,
    defaultCountry,
    ...rest
}) {
    const { t } = useContext(TranslatorContext)
    const [selectedCountry, setSelectedCountry] = useState();

    const handleCountryChange = (country) => {
        setSelectedCountry(country);
        
        if (phoneNumber && country) {
            try {
                const formattedNumber = formatPhoneNumber(phoneNumber, country);
                if (onChange && formattedNumber) {
                    onChange(formattedNumber);
                }
            } catch (error) {
                console.log('Error formatting phone number:', error);
            }
        }
        
        // Call parent component's country change handler if provided
        if (onCountryChange) {
            onCountryChange(country);
        }
    };

    const handlePhoneChange = (value) => {
        console.log('Phone number changed:', value);
        if (onChange) {
            onChange(value);
        }
    };
    return (
        <div className={`mc-label-field-group ${ label ? labelDir || "label-col" : "" }`} style={{marginTop:'20px', marginBottom:'20px'}}> 
            {label && <label className="mc-label-field-title">{ t(label) } {required && <span style={{color:'red'}}>*</span>}</label>}
            

            <PhoneInput
                placeholder={placeholder || "Enter phone number"}
                value={phoneNumber}
                country={selectedCountry}
                onChange={handlePhoneChange}
                onCountryChange={handleCountryChange}
                international
                defaultCountry={defaultCountry || 'US'}
                limitMaxLength={15}
                {...rest}
                className = {`mc-label-field-input ${ fieldSize || "w-md h-sm" }`} 
            />
            {errorMessage !=='' && <span className="mc-label-field"  style={{ color:'red'}} >{t(errorMessage)}</span>}
            
        </div>
    )
}